import {defineAsyncComponent} from 'vue';

const backupRestore = defineAsyncComponent(() => import('@/views/utility/backup/BackupRestore.vue'));

const storageForm = defineAsyncComponent(() => import('@/views/utility/backup/StorageForm.vue'));

const restoreProcess = defineAsyncComponent(() => import('@/views/utility/backup/RestoreProcess.vue'));

const databaseInfo = defineAsyncComponent(() => import('@/views/dictionary/dataManagement/DatabaseInfo.vue'));

const accessDatabase = defineAsyncComponent(() => import('@/views/dictionary/dataManagement/AccessDatabase.vue'));

const databaseHistory = defineAsyncComponent(() => import('@/views/dictionary/dataManagement/DatabaseHistory.vue'));

const backupDataTT23 = defineAsyncComponent(() => import('@/views/utility/backup/BackupDataTT23.vue'));

const conversionOfAccountingSystemPopup = defineAsyncComponent(
  () => import('@/views/dictionary/dataManagement/conversionOfAccountingSystem/ConversionOfAccountingSystemPopup.vue'),
);

const conversionOfAccountingSystemResultPopup = defineAsyncComponent(
  () =>
    import(
      '@/views/dictionary/dataManagement/conversionOfAccountingSystem/ConversionOfAccountingSystemResultPopup.vue'
    ),
);

export function registerDatabase(app) {
  app.component('BackupRestore', backupRestore);
  app.component('StorageForm', storageForm);
  app.component('RestoreProcess', restoreProcess);
  app.component('DatabaseInfo', databaseInfo);
  app.component('AccessDatabase', accessDatabase);
  app.component('DatabaseHistory', databaseHistory);
  app.component('BackupDataTT23', backupDataTT23);
  app.component('ConversionOfAccountingSystemPopup', conversionOfAccountingSystemPopup);
  app.component('ConversionOfAccountingSystemResultPopup', conversionOfAccountingSystemResultPopup);
}
